import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const luckyCharmBadgeDefinition: BoggleBadgeDefinition = {
  category: 'speed',
  description: 'Play the same word 3 times in a row',
  iconId: 'luckyCharm',
  id: 'luckyCharm',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Lucky Charm',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
